import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { format, parseISO } from 'date-fns';
import { ReactElement } from 'react';

import { CompanyUsage, Plan } from '../../generated-api';
import InvoicePdfDownloadButton from './InvoicePdfDownloadButton';

type CompanyUsageTableData = CompanyUsage & {
  tax: number;
  confirmed: boolean;
  plan?: Plan;
};

type Props = {
  companyUsageDataSource: CompanyUsageTableData[] | undefined;
  loading: boolean;
};

const CompanyUsageTable = ({ companyUsageDataSource, loading }: Props) => {
  const columns: ColumnsType<CompanyUsageTableData> = [
    {
      title: 'ご利用月',
      dataIndex: 'month',
      render: (value, record) => {
        const formattedDate = format(parseISO(value), 'yyyy/M');
        if (record.confirmed) {
          return formattedDate;
        } else {
          return '（未確定）' + formattedDate;
        }
      },
      width: 300,
      align: 'right',
    },
    {
      title: '利用料金（税抜き）',
      dataIndex: 'bill',
      render: renderColumn,
      width: 300,
      align: 'right',
    },
    {
      title: '消費税',
      dataIndex: 'tax',
      render: renderColumn,
      width: 300,
      align: 'right',
    },
    {
      title: '利用料金（税込み）',
      dataIndex: 'bill_with_tax',
      render: renderColumn,
      width: 300,
      align: 'right',
    },
    {
      title: '請求書',
      dataIndex: 'plan',
      render: renderInvoiceDownloadButton,
      align: 'center',
    },
  ];

  return (
    <Table
      bordered={true}
      columns={columns}
      dataSource={companyUsageDataSource}
      loading={loading}
      pagination={false}
      rowKey="month"
    />
  );
};

function renderColumn(value: number, record: CompanyUsageTableData): ReactElement {
  const formattedValue = value.toLocaleString();
  return <>{record.confirmed ? formattedValue + '円' : '（未確定）' + formattedValue + '円'}</>;
}

function renderInvoiceDownloadButton(value: Plan | undefined, record: CompanyUsageTableData): ReactElement {
  const currentMonth = format(new Date(), 'yyyy-MM');
  if (record.month === currentMonth || !value || value.plan_id === 'planC') {
    // planC はトライアルのため請求書不要
    return <></>;
  }

  const usage = {
    bill: record.bill,
    bill_with_tax: record.bill_with_tax,
    company_id: record.company_id,
    free_usage: record.free_usage,
    month: record.month,
    usage: record.usage,
  };

  return (
    <InvoicePdfDownloadButton plan={value} usage={usage}>
      ダウンロード
    </InvoicePdfDownloadButton>
  );
}

export default CompanyUsageTable;
